export const mockAPIPath = {
    PRODUCT_LEVEL_DATA: "",
    REPORT_CARD_SUMMARY: "",
    ORDER_LEVEL_DATA: "",
    LINK_REGISTER_URL:""

};

export const serverAPIPath = {
    PRODUCT_LEVEL_DATA: "/reports/products",
    REPORT_CARD_SUMMARY: "/reports/summary",
    ORDER_LEVEL_DATA: "/reports/orders",
    LINK_REGISTER_URL:"/linkRegistry/urls",
};





